export const getTableEntry = (id) => (state) => state.table.tableEntries?.[id] || null;

